export const EXSBPAYMENTWAY_CREATE_RESET = 'EXSBPAYMENTWAY_CREATE_RESET'
export const EXSBPAYMENTWAY_CREATE_SET_CREATED = 'EXSBPAYMENTWAY_CREATE_SET_CREATED'
export const EXSBPAYMENTWAY_CREATE_SET_ERROR = 'EXSBPAYMENTWAY_CREATE_SET_ERROR'
export const EXSBPAYMENTWAY_CREATE_SET_VIOLATIONS = 'EXSBPAYMENTWAY_CREATE_SET_VIOLATIONS'
export const EXSBPAYMENTWAY_CREATE_TOGGLE_LOADING = 'EXSBPAYMENTWAY_CREATE_TOGGLE_LOADING'
